// At least two labels (a bare TLD is never a mailbox domain), each 1-63 characters, letters/digits/
// hyphens only, never starting or ending with a hyphen — the same shape `@IsFQDN` checks server-side.
const DOMAIN_PATTERN = /^(?!-)[a-z0-9-]{1,63}(?<!-)(\.(?!-)[a-z0-9-]{1,63}(?<!-))+$/i;

/** Atomic predicate, reused by `areEmailDomainsWellFormed` — kept separate so it can be tested and
 * reused on its own (`guides/forms.md` §1.1). */
function isWellFormedDomain(domain: string): boolean {
	return DOMAIN_PATTERN.test(domain.trim());
}

export default isWellFormedDomain;
